import { formatISO } from "date-fns";

const utcDatetimeFormatter = Intl.DateTimeFormat("en-GB", {
	year: "numeric",
	month: "numeric",
	day: "numeric",
	hour: "numeric",
	minute: "numeric",
	second: "numeric",
	hour12: false,
	timeZone: "UTC"
});

const utcDateFormatter = Intl.DateTimeFormat("en-GB", {
	year: "numeric",
	month: "numeric",
	day: "numeric",
	timeZone: "UTC"
});

export const getFormattedStartTime = (t) => {
	const startTime = new Date(t);
	return formatISO(startTime).substring(0, 19);
};

export const getFormattedEndTime = (t) => {
	const endTime = new Date(t);
	endTime.setHours(endTime.getHours() + 24);
	return formatISO(endTime).substring(0, 19);
};

export const getDisplayDate = (t, errorMsg) => {
	const isZeroTime = t === "0001-01-01T00:00:00Z";

	if (t && !isZeroTime) {
		const date = new Date(t);
		return utcDateFormatter.format(date);
	}

	if (!errorMsg) {
		return "Unavailable";
	}

	return errorMsg;
};

export const getDisplayDateTime = (t, errorMsg, s) => {
	const displayDate = getDisplayDate(t, errorMsg, s);
  
	if (typeof displayDate === "string" && displayDate !== "Unavailable") {
		const date = new Date(t);
		return utcDatetimeFormatter.format(date);
	}
  
	return displayDate;
};

export const getDisplayDateAlt = (t, errorMsg) => {
	let isZeroTime = t === "0001-01-01T00:00:00Z";

	if (isZeroTime) {
		return "";
	}

	if (t && !isZeroTime) {
		const date = new Date(t);
		return utcDateFormatter.format(date);
	}

	if (!errorMsg) {
		return "";
	}

	return errorMsg;
};

export const getCurrentDateTruncated = () => {
	return new Date(new Date().toUTCString());
};

export const getDateFromDayNumber = (dayNumber) => {
	if (dayNumber === undefined) {
		return "";
	}

	const initDate = getCurrentDateTruncated();
	return initDate.setUTCDate(initDate.getUTCDate() + dayNumber);
};

export const getUpdatedDate = (d, t, p) => {
	const time = t.split(":");
	const isoDate = formatISO(d);
	if (p === "despatch") return `${isoDate.substring(0, 11)}${time[0]}:${time[1]}:00`;
	if (p === "stock") return `${isoDate.substring(0, 11)}${time[0]}:${time[1]}:00.000Z`;
};
